<div class="mt-5 text-center">
  <p [innerHTML]="'Error.Error500' | translate"></p>
</div>